(function () {

  var $container = $(".c-menu");
  var $label = $('*[data-opens-menu]');
  var $checkbox = $container.find($('input[type="checkbox"]'));

  // Functions that closes everything when clicking outside
  $(document).click(function (e) {
    // if the target of the click isn't the container nor a descendant of the container
    if (!$container.is(e.target) && $container.has(e.target).length === 0 && $checkbox.is(':checked')) {
      $container.find($label).trigger('click');
      $checkbox.prop("checked", false);
      //console.log($checkbox[0].checked);
    }
  });

})();
